import {
  CheckResourceState,
  checkResourceStateToText,
} from 'features/security-insights';

import { FilterSelect } from '@cast/shared-search-ui';

export const ResourcesSelect = () => {
  return (
    <FilterSelect
      criterion="resource"
      startAdornment="Resources:"
      sx={{ minWidth: 230, width: 400 }}
      options={[
        {
          title: checkResourceStateToText[CheckResourceState.AFFECTED],
          value: CheckResourceState.AFFECTED,
        },

        {
          title: checkResourceStateToText[CheckResourceState.UNAFFECTED],
          value: CheckResourceState.UNAFFECTED,
        },
      ]}
    />
  );
};
